import { HStack, VStack } from "@chakra-ui/react";
import { useIntl } from "react-intl";

import { changePasswordFormMessages } from "@pages/change-password/ui/messages";
import { useFormatErrorMessages } from "@shared/libs/validators/hooks/use-format-error-messages";
import { getPasswordValidationState } from "@shared/libs/validators/schemas/password";
import { Icon } from "@shared/ui/chakra/data-display/icon";
import { Typography } from "@shared/ui/chakra/typography/typography";

type Props = {
  value?: number | readonly string[] | string | undefined;
  isPasswordEmpty?: boolean;
};

const RequirementItem = ({
  text,
  isMet,
  isPasswordEmpty,
}: {
  text: string;
  isMet: boolean;
  isPasswordEmpty: boolean;
}) => {
  const getIconProps = () => {
    if (isPasswordEmpty) {
      return {
        color: "gray.800",
        name: "Check" as const,
      };
    } else if (isMet) {
      return {
        color: "yellowGreen.600",
        name: "Check" as const,
      };
    } else {
      return {
        color: "red.500",
        name: "XClose" as const,
      };
    }
  };
  const { color, name } = getIconProps();

  return (
    <HStack alignItems="center" gap="1.5">
      <Icon color={color} name={name} size="sm" />
      <Typography
        color={color}
        fontSize="sm"
        textStyle="body2"
        textTransform="none"
      >
        {text}
      </Typography>
    </HStack>
  );
};

export const PasswordValidIndicator = ({
  value,
  isPasswordEmpty = false,
}: Props) => {
  const rulesState = getPasswordValidationState(
    typeof value !== "string" ? "" : value,
  );
  const formatFormErrorMessage = useFormatErrorMessages();
  const { formatMessage } = useIntl();
  return (
    <VStack align="start" gap={0}>
      <Typography color="text.fg_muted" textStyle="label" textTransform="none">
        {formatMessage(changePasswordFormMessages.continueButton)}
      </Typography>

      {rulesState.map((rule) => (
        <RequirementItem
          key={rule.id}
          text={formatFormErrorMessage(rule.id, rule.params)}
          isMet={rule.isValid}
          isPasswordEmpty={isPasswordEmpty}
        />
      ))}
    </VStack>
  );
};
